/* eslint-disable padding-line-between-statements */
import React from 'react';
import { InstanceProvider, ThemeProvider } from '@stepstone-genesis/components';
import {
  LocaleProvider,
  PageContextParams,
  PlatformSiteProvider,
} from '@stepstone-platform/platform-apis';
import { TranslationsProvider } from '@stepstone-platform/i18n/compat';
import * as Dresscode from '@stepstone-genesis/dresscode';
import translations from '@stepstone-fragment/login-registration/translations.json';
import genesisInstance from 'genesis-instance';
import { useLanguageSwitch } from '../../../../tools/hooks/useLanguageSwitch';

type Props = {
  children: React.ReactNode;
  context: PageContextParams;
  themeId?: Dresscode.ThemeBrandKeys;
};
export function EndpointProviders({ children, context, themeId }: Props) {
  // On server: create cache per render
  const isServer = typeof window === 'undefined';
  // Hooks are always called, top-level
  const clientCache = React.useState(() => genesisInstance.createCache())[0];
  const cache = isServer ? genesisInstance.createCache() : clientCache;

  const { updatedLocale } = useLanguageSwitch(context.locale);

  return (
    <InstanceProvider instance={genesisInstance} cache={cache}>
      <ThemeProvider theme={themeId ? Dresscode[themeId] : undefined}>
        <PlatformSiteProvider platformSite={context.platformSite}>
          <LocaleProvider locale={updatedLocale ?? context.locale}>
            <TranslationsProvider
              platformSite={context.platformSite}
              translationsJSON={translations}
              defaultLocale={updatedLocale ?? context.locale}
              defaultNS={['default']}
            >
              {children}
            </TranslationsProvider>
          </LocaleProvider>
        </PlatformSiteProvider>
      </ThemeProvider>
    </InstanceProvider>
  );
}
